import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";

const AddIngredientForm = ({ addIngredient }) => {
    const [name, setName] = useState("");
    const [amount, setAmount] = useState("");
    const [unit, setUnit] = useState("ks");
    const [expiration, setExpiration] = useState("");
    /*const [expiration, setExpiration] = useState(() => {
        const today = new Date();
        today.setDate(today.getDate() + 30);
        return today.toISOString().split("T")[0];
    });*/


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!name || !amount) {
            alert("Vyplňte název a množství!");
            return;
        }

        const newIngredient = {
            id: Date.now(),
            name,
            amount: parseFloat(amount.replace(",", ".")), // Konverze na číslo
            unit,
            expiration
        };

        addIngredient(newIngredient);

        // Vyčištění formuláře
        setName("");
        setAmount("");
        setUnit("ks");
        setExpiration("");
    };

    return (
        <Form onSubmit={handleSubmit} className="mb-4">
            <label className="lead">Přidat novou ingredienci</label>
            <Row className="g-3">
                <Col xs={12} md={3}>
                    <Form.Control
                        type="text"
                        placeholder="Název ingredience"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                </Col>
                <Col xs={12} md={2}>
                    <Form.Control
                        type="number"
                        placeholder="Množství"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        min="0" step="0.1"
                        required
                    />
                </Col>
                <Col xs={12} md={2}>
                    <Form.Select value={unit} onChange={(e) => setUnit(e.target.value)}>
                        <option value="ks">Kusy</option>
                        <option value="l">Litry</option>
                        <option value="g">Gramy</option>
                        <option value="ml">Mililitry</option>
                        <option value="kg">Kilogramy</option>
                    </Form.Select>
                </Col>
                <Col xs={12} md={3}>
                    <Form.Control
                        title="Expirace"
                        type="date"
                        value={expiration}
                        onChange={(e) => setExpiration(e.target.value)}
                    />
                </Col>
                <Col xs={12} md={2}>
                    <Button type="submit" variant="success" className="w-100">
                        <i className="bi bi-cart-plus-fill"></i> Přidat
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};

export default AddIngredientForm;
